/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SuccessResponseData
 */
export interface SuccessResponseData {
  /**
   *
   * @type {boolean}
   * @memberof SuccessResponseData
   */
  success?: boolean
}

export function SuccessResponseDataFromJSON(json: any): SuccessResponseData {
  return SuccessResponseDataFromJSONTyped(json, false)
}

export function SuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuccessResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success') ? undefined : json['success']
  }
}

export function SuccessResponseDataToJSON(value?: SuccessResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    success: value.success
  }
}
